<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Administración de planes</span>
  
    <div class="absolute right-0 content-center">
      <ul class="flex-row flex content-center gap-2">
        <li>
          <button mat-icon-button (click)="openDialogCreate()">
            <mat-icon>add</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </mat-toolbar>

  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
   
    <mat-form-field  appearance="outline" class="example-full-width" style="padding-left: 10px; font-size: smaller;">
      <mat-label>Club</mat-label>
      <mat-select [(ngModel)]="clubSelect" (selectionChange)="cambioClubBuscar()">
        <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
          {{clubTmp.nombre}}
        </mat-option>
      </mat-select>

    </mat-form-field>
  </div>

  <div class="margin-container apearAnimation">
   
    <div class="mat-elevation-z0 contenedorTabla">
      <table mat-table [dataSource]="dataSource">
  
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef>descripción</th>
            <td mat-cell *matCellDef="let element">{{ element.descripcion }}</td>
          </ng-container>

          <ng-container matColumnDef="mesesDeVigencia">
            <th mat-header-cell *matHeaderCellDef>Vigencia (meses)</th>
            <td mat-cell *matCellDef="let element">{{ element.mesesDeVigencia }}</td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let element">${{ element.valor }}</td>
          </ng-container>

  <!--         <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">{{ element.activo }}</td>
          </ng-container> -->

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <mat-slide-toggle [checked]="element.activo" (change)="onToggle($event, element)"></mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="botones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button
                color="accent"
                mat-icon-button
                aria-label="Edit"
                (click)="edit(element)"
              >
                <mat-icon>edit</mat-icon>
              </button>
    
            </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
    </div>
  </div>
  